import "../styles/footer.scss";
import { Link } from "react-router-dom";
import { FadeInUp } from "./motion";
import { socialLinks } from "../content/contact";
import facebook from "../images/icons/sm/facebook.webp";
import insta from "../images/icons/sm/instagram.webp";
import x from "../images/icons/sm/x_transparent.png";

const socialIcons = {
  Facebook: facebook,
  Instagram: insta,
  "Twitter / X": x,
};

const Footer = () => {
  return (
    <FadeInUp as="footer" className="footer" id="footer">
      <div className="footer__container">
        <div className="footer__links">
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
        </div>
        <div className="footer__social">
          {socialLinks.map((link) => (
            <a
              key={link.name}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={link.handle ? `${link.name} ${link.handle}` : link.name}
              className="footer__social-link"
            >
              <img
                src={socialIcons[link.name]}
                alt=""
                aria-hidden="true"
              />
            </a>
          ))}
        </div>
      </div>
      <p className="footer__credit">
        Designed & developed by{" "}
        <a
          href="https://nitrosolutions.co.uk/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Nitro Solutions
        </a>
      </p>
    </FadeInUp>
  );
};

export default Footer;
